

export default class UpdateVoiceFileRequest  {
	Id?: string = '';
	Index: number = 0;
	IsPaid: boolean = false;
	Name?: string = '';
	Description?: string = '';
	Base64Content?: string = '';
	constructor(obj?: Partial<UpdateVoiceFileRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
